<div (click)="vote()" class="vote--wrapper">
  <ark-icon
    [icon]="icon"
    size="small"
    [color]="voted ? 'cta' : 'inactive'"
  ></ark-icon>
  <div class="value">{{ votes | kiloformatter }}</div>
</div>
